import { render, staticRenderFns } from "./ListRequestedGenericCOD.vue?vue&type=template&id=7c7ec3e0&scoped=true"
import script from "./ListRequestedGenericCOD.vue?vue&type=script&lang=js"
export * from "./ListRequestedGenericCOD.vue?vue&type=script&lang=js"
import style0 from "./ListRequestedGenericCOD.vue?vue&type=style&index=0&id=7c7ec3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ec3e0",
  null
  
)

export default component.exports